import React, { Component } from 'react';
import Table from '../../../../components/UI/Table/Table';
import { CASE_VIEW_COLUMNS, DEFAULT_PAGE_SIZE } from './constant';
import '../style.scss';

class TableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks || {},
            pageSize: DEFAULT_PAGE_SIZE,
            currentPageIndex: 0,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks || {},
            });
        }
    }

    handleFileDownload = (fileKey) => {
        if (fileKey && this.props.onDownloadFile) {
            this.props.onDownloadFile(fileKey);
        }
    }

    render() {
        const recordList = this.state.data?.recordList ? this.state.data.recordList : [];
        const totalPages = this.state.data?.numberOfPages ? this.state.data.numberOfPages : 0;

        return (
            <Table
                data={recordList}
                columns={CASE_VIEW_COLUMNS(this)}
                defaultSorted={[
                    {
                        id: 'uploadedDate',
                        desc: true,
                    },
                ]}
                className="-striped -highlight"
                noDataText="No Data found"
                multiSort={false}
                pages={totalPages}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual
                loading={this.props.loading}
                onPageChange={(pageIndex) => {
                    this.setState({ currentPageIndex: pageIndex });
                    this.props.onFetchPage({
                        pageNumber: pageIndex,
                        pageSize: this.state.pageSize,
                    });
                }}
                onPageSizeChange={(pageSize) => {
                    this.setState({ pageSize });
                    this.props.onFetchPage({
                        pageNumber: 0,
                        pageSize,
                    });
                }}
            />
        );
    }
}

export default TableView;
